import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  Typography,
  styled,
} from "@material-ui/core";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import { Split } from "../../utils/Split";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router";
import moment from "jalali-moment";
import useCustomState from "../../hooks/State";
import EditCounterModal from "./ModalEditCounter";
import { useMountAPI } from "../../hooks/APICall";
import Call from "../../service/API";
import {
  GREEN_PRIMRY,
  ERROR_COLOR,
  BLUE_COLOR,
  DARK_SIDEBAR,
} from "../../utils/const";
import CorrectCheck from "../../assets/img/correct-check.png";
import HazardCheck from "../../assets/img/error-blink-5.gif";
import ModalCounterExcel from "./ModalCounterExcel";
import { ExpandMore } from "@material-ui/icons";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));
const CounterTableHeader = (props) => {
  const expanded = useCustomState(false);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };
  const categories = useSelector((state) => state.categories);
  const permissions = useSelector((state) => state.user.permissions);

  const thisProject = useCustomState({});
  const editCounterModalOpen = useCustomState(false);
  const modalCounterExcelOpen = useCustomState(false);

  const counterInfo = useCustomState({});
  const isLoading = useCustomState(true);
  const lastConsumption = useCustomState({});

  const history = useHistory();
  const counterChange = (value) => {
    counterInfo.handleChange(value);
  };

  const counterUtils = {
    serial: props.serial,
    isLoading: isLoading,
    counterInfo: counterInfo,
  };

  const getLastUtils = {
    serial: props.serial,
    lastConsumption: lastConsumption,
  };

  useMountAPI(fetchCounterInfo, counterUtils);
  useMountAPI(fetchGetLast, getLastUtils);

  useEffect(() => {
    if (!isLoading.value) {
      props.counterInfo.handleChange(counterInfo.value);
    }
  }, [isLoading.value]);

  if (!isLoading.value) {
    const counterInfoTemp = counterInfo.value[0];
    const showEditBtn = !!counterInfoTemp?.water_meter_module_info
      ?.water_meter_module_id
      ? counterInfoTemp.water_meter_module_info.water_meter_module_id
      : true && counterInfoTemp.water_meter_project_info?.project_id;
    let validationStatus, activationStatus, commandStatus;
    const statusStyle = {
      color: "#fff",
      backgroundColor: "green",
      fontSize: "12px",
      borderRadius: "4px",
      paddingRight: "4px",
      paddingLeft: "4px",
      marginRight: "8px",
    };
    if (counterInfoTemp.water_meter_validation) {
      const validationStyle = { ...statusStyle };
      validationStyle.backgroundColor = GREEN_PRIMRY;
      validationStatus = (
        <>
          <span style={validationStyle}>تایید شده</span>
        </>
      );
    } else {
      const validationStyle = { ...statusStyle };
      validationStyle.backgroundColor = ERROR_COLOR;
      validationStatus = (
        <>
          <span style={validationStyle}>تایید نشده</span>
        </>
      );
    }

    if (counterInfoTemp.water_meter_activation) {
      const activationStyle = { ...statusStyle };
      activationStyle.backgroundColor = GREEN_PRIMRY;
      activationStatus = (
        <>
          <span style={activationStyle}>فعال شده</span>
        </>
      );
    } else {
      const activationStyle = { ...statusStyle };
      activationStyle.backgroundColor = ERROR_COLOR;
      activationStatus = (
        <>
          <span style={activationStyle}>فعال نشده</span>
        </>
      );
    }

    if (counterInfoTemp.water_meter_condition) {
      const commandStyle = { ...statusStyle };
      commandStyle.backgroundColor = GREEN_PRIMRY;
      commandStatus = (
        <>
          <span style={commandStyle}>دارد</span>
        </>
      );
    } else {
      const commandStyle = { ...statusStyle };
      commandStyle.backgroundColor = ERROR_COLOR;
      commandStatus = (
        <>
          <span style={commandStyle}>ندارد</span>
        </>
      );
    }

    const description = counterInfoTemp.other_information?.description;
    const counterDescription = description ? description : "وارد نشده";

    const goToHowToCalculateBill = () => {
      history.push("/admin/counter/" + props.serial + "/how-to-calculate-bill");
    };

    const goToBills = () => {
      history.push("/admin/counter/" + props.serial + "/bills");
    };

    const openEditCounterModal = () => {
      editCounterModalOpen.handleChange(true);
    };
    const openCounterExcelModal = () => {
      modalCounterExcelOpen.handleChange(true);
    };

    const showBillButtons = permissions.includes("Base") ? true : false;

    let calculated, received, image, manualNumber;
    if (
      counterInfoTemp.water_meter_tag_info?.water_meter_tag_name.includes("آب")
    ) {
      calculated = counterInfoTemp.all_consumptions_value;
      manualNumber = counterInfoTemp.water_meter_manual_number;
      received = lastConsumption.value.cumulative_value
        ? lastConsumption.value.cumulative_value
        : 0;
      image = calculated === received ? CorrectCheck : HazardCheck;
    } else {
      calculated = counterInfoTemp.all_consumptions_value;
      received = counterInfoTemp.all_consumptions_value;
      image = CorrectCheck;
    }

    return (
      <>
        <EditCounterModal
          open={editCounterModalOpen}
          counter={counterInfo.value[0]}
          altCounter={counterChange}
          counterInfo={counterInfo}
        />
        <ModalCounterExcel
          open={modalCounterExcelOpen}
          counter={counterInfo.value[0]}
        />
        <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
          <Grid item sx={12} sm={12} md={12} lg={12}>
            <Card style={{ width: "100%", marginTop: "16px" }}>
              <CardHeader
                style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
                title={`اطلاعات کنتور ${counterInfoTemp.water_meter_name}`}
                action={
                  <ExpandMoree
                    expand={expanded.value}
                    onClick={handleExpandClick}
                    aria-expanded={expanded.value}
                    aria-label="show more"
                  >
                    <ExpandMore />
                  </ExpandMoree>
                }
              />
              <Collapse in={expanded.value} timeout="auto" unmountOnExit>
                <CardContent
                  style={{
                    padding: "16px",
                  }}
                >
                  <Grid container>
                    <Grid item sx={12} sm={12} md={7} lg={7}>
                      <Grid align="center" item sx={12} sm={12} md={12} lg={12}>
                        <div
                          style={{
                            maxWidth: "820px",
                            marginTop: "48px",
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            paddingTop: "24px",
                            paddingBottom: "24px",
                            height: "380px",
                            overflow: "scroll",
                          }}
                        >
                          <Table
                            style={{
                              backgroundColor: "#fff",
                              padding: "16px",
                              borderRadius: "12px",
                              marginTop: "8px",
                            }}
                            aria-label="simple table"
                          >
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <Typography>شماره سریال</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {counterInfoTemp.water_meter_serial}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>نوع کنتور</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {convertNumbers(
                                    counterInfoTemp.water_meter_tag_info
                                      ?.water_meter_tag_name +
                                      " - " +
                                      counterInfoTemp.water_meter_type_info
                                        ?.water_meter_type_name
                                  )}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>وضعیت تایید</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {validationStatus}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>وضعیت فعال سازی</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {activationStatus}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>قابلیت دریافت دستور</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {commandStatus}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>وضعیت صحت مقادیر مصرف</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <img src={image} width={30} height={30} />
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>
                                    <span>عدد مکانیکی کنتور </span>
                                    <span style={{ fontSize: "11px" }}>
                                      ({"offset"})
                                    </span>
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {convertNumbers(manualNumber)}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>
                                    <span>میزان مصرف </span>
                                    <span style={{ fontSize: "11px" }}>
                                      ({"محاسبه شده"})
                                    </span>
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {convertNumbers(calculated)}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Typography>
                                    <span>میزان مصرف </span>
                                    <span style={{ fontSize: "11px" }}>
                                      ({"دریافت شده"})
                                    </span>
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {convertNumbers(received)}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid
                      style={{ paddingRight: "24px" }}
                      align="center"
                      item
                      sx={12}
                      sm={12}
                      md={5}
                      lg={5}
                      className="counter-btns"
                    >
                      <div
                        style={{
                          maxWidth: "820px",
                          height: "380px",
                          marginTop: "48px",
                          backgroundColor: "#fff",
                          borderRadius: "12px",
                          padding: "24px",
                          overflow: "scroll",
                          textAlign: "right",
                        }}
                      >
                        <div style={{ height: "190px", overflow: "scroll" }}>
                          <Typography
                            align="left"
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            {"توضیحات کنتور"}
                          </Typography>
                          <Typography align="left" style={{ fontSize: "14px" }}>
                            {counterDescription}
                          </Typography>
                        </div>
                        <hr />
                        <Typography
                          align="left"
                          style={{ fontSize: "16px", fontWeight: "bold" }}
                        >
                          {"امکانات"}
                        </Typography>
                        <br />
                        <Button
                          onClick={openEditCounterModal}
                          style={{
                            backgroundColor: "#ed6c02",
                            color: "#fff",
                            marginRight: "4px",
                            marginLeft: "4px",
                            marginBottom: "4px",
                            display: showEditBtn ? "" : "none",
                          }}
                          variant="contained"
                        >
                          ویرایش کنتور
                        </Button>
                        <Button
                          onClick={goToHowToCalculateBill}
                          style={{
                            backgroundColor: DARK_SIDEBAR,
                            color: "#fff",
                            marginRight: "4px",
                            marginLeft: "4px",
                            marginBottom: "4px",
                            display: showBillButtons ? "" : "none",
                          }}
                          variant="contained"
                        >
                          نحوه محاسبه قبض
                        </Button>
                        <Button
                          onClick={goToBills}
                          style={{
                            backgroundColor: BLUE_COLOR,
                            color: "#fff",
                            marginRight: "4px",
                            marginLeft: "4px",
                            marginBottom: "4px",
                            display: showBillButtons ? "" : "none",
                          }}
                          variant="contained"
                        >
                          مشاهده قبض ها
                        </Button>
                        <Button
                          onClick={openCounterExcelModal}
                          style={{
                            backgroundColor: GREEN_PRIMRY,
                            color: "#fff",
                            marginRight: "4px",
                            marginLeft: "4px",
                            marginBottom: "4px",
                            display: showEditBtn ? "" : "none",
                          }}
                          variant="contained"
                        >
                          خروجی اکسل
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        </Grid>
      </>
    );
  } else {
    return null;
  }
};

export default CounterTableHeader;

const fetchCounterInfo = (utils) => {
  const serial = utils.serial;
  const isLoading = utils.isLoading;
  const counterInfo = utils.counterInfo;

  const data = {
    water_meter_serial: serial,
  };

  Call("POST", "watermeters/admin/getOne", data)
    .then((response) => {
      // console.log("fetch counter info: ", response);
      if (response.data.code == 200) {
        counterInfo.handleChange(response.data.data);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const fetchGetLast = (utils) => {
  const serial = utils.serial;
  const lastConsumption = utils.lastConsumption;

  const data = {
    water_meter_serial: serial,
  };

  Call("POST", "watermeters/admin/getLast/consumption", data).then(
    (response) => {
      // console.log("last consumption: ", response);
      if (response.data.code === 200) {
        lastConsumption.handleChange(response.data.data);
      }
    }
  );
};
